import EtablissementPaymentAutoSalaire from '@/generated/controls/etablissement/EtablissementPaymentAutoSalaire.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: EtablissementPaymentAutoSalaire
})
